import React, {
  useState,
  useRef,
  useImperativeHandle,
  forwardRef,
  useEffect,
} from "react";
import { Input, Modal } from "semantic-ui-react";
import CardPatientSearch from "./CardPatientSearch";
import PropTypes from "prop-types";
import CardPatientOldName from "./CardPatientOldName";
import axios from "axios";

const PatientSearchBox = forwardRef((props, ref) => {

  const isMounted = useRef(true)
  const [openCardPatientSearch, setOpenCardPatientSearch] = useState(false);
  const [openCardPatientOldName, setOpenCardPatientOldName] = useState(false);
  const [patientFullName, setPatientFullName] = useState(null);
  const [hnInput, setHNInput] = useState(props.initialValue);
  const inputRef = useRef();

  const [axioSource, setAxioSource] = useState(null)

  const [patientsLoading, setPatientsLoading] = useState(false);
  const [patientOldNamesLoading, setPatientOldNamesLoading] = useState(false);
  const [patients, setPatients] = useState([]);
  const [nationalities, setNationalities] = useState([]);
  const [patientOldNames, setPatientOldNames] = useState([]);
  const [numberOfPage, setNumberOfPage] = useState(props.numberOfPage);
  const [currentPage, setCurrentPage] = useState(props.currentPage);

  const [patientId, setPatientId] = useState(null)
  const [isAPILoading, setIsAPILoading] = useState(false)


  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current.focus();
    },
    clear: () => {
      setHNInput("");
    },
    openPatientSearch: () => {
      setOpenCardPatientSearch(true);
    },
    value: () => {
      return hnInput;
    },
    setValue: (hn) => {
      setHNInput(hn);
    },
    getPatientId: () => {
      return patientId
    }
  }));

  const handleCloseCardPatientSearch = () => {
    setOpenCardPatientSearch(false);
  };

  const handleCloseCardPatientOldName = () => {
    setOpenCardPatientOldName(false);
  };

  const handleOnChangeHN = (e) => {
    console.log(5)
    setHNInput(e.target.value);
  };

  const handleOpenCardPatientSearch = () => {
    setOpenCardPatientSearch(true);
  };

  const handleOpenModPatientOldName = (patientId, hn, fullName) => {
    setOpenCardPatientOldName(true);
    setHNInput(hn);
    setPatientFullName(fullName);
    if (props.onGetPatientOldName) {
      props.onGetPatientOldName(patientId);
    } else {
      loadPatientOldName(patientId);
    }
  };

  /* For controller */
  const loadPatients = async (params) => {
    if (!props.controller) {
      return;
    }
    if (axioSource) {

      axioSource.cancel("cancel")
    }
    const source = axios.CancelToken.source();
    setIsAPILoading(true)
    setAxioSource(source)

    let pCurrentPage = params.patientCurrentPage;
    if (!params.patientCurrentPage) {
      pCurrentPage = currentPage;
    }
    setCurrentPage(pCurrentPage);

    // Create params
    let newParams = {
      ...params,
      patientCurrentPage: pCurrentPage,
      ...(source && { cancelToken: source.token })
    };
    const [data, error, totalPage] = await props.controller.getPatientList(
      newParams
    );

    if (error === "cancel") {
      console.log("Cancel Not Stop Loading")
    } else {
      console.log(" setIsAPILoading false")
      setIsAPILoading(false)
    }

    if (data) {
      setPatients(data);
      setNumberOfPage(totalPage);
    }
  };

  const loadNationality = async () => {
    if (!props.controller) {
      return;
    }
    const [data, error] = await props.controller.getNatinalities();
    if (data) {
      setNationalities(data);
    }
  };

  const handlePaginationChange = async (params) => {
    await loadPatients(params);
  };

  const loadPatientOldName = async (patientId) => {
    if (!props.controller) {
      return;
    }
    const [data, error] = await props.controller.getPatientOldName(patientId);
    if (data) {
      setPatientOldNames(data);
    }
  };

  const handleOnKeyPressHN = async (ev) => {
    const hn = ev.target.value.toUpperCase()
    if (ev.key === "Enter") {
      let [res, err, network] = [null, null, null]
      if (props.controller) {
        [res, err, network] = await props.controller.getPatientByHN(hn)
      }
      if (props.onGetPatientByHN) {
        [res, err, network] = await props.onGetPatientByHN(hn)
      }

      if (!network?.data) {
        handleOpenCardPatientSearch()
      } else {
        const { id, hn, full_name } = network.data
        props.onEnter && props.onEnter(id, hn, full_name)
      }
    }
  }
  /********************* */

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    if (props.patientList) {
      setPatients(props.patientList);
    }
  }, [props.patientList]);

  useEffect(() => {
    if (props.nationalitiesList) {
      setNationalities(props.nationalitiesList);
    }
  }, [props.nationalitiesList]);

  useEffect(() => {
    if (props.patientOldNameDataList) {
      setPatientOldNames(props.patientOldNameDataList);
    }
  }, [props.patientOldNameDataList]);

  useEffect(() => {
    if (props.numberOfPage !== null) {
      setNumberOfPage(props.numberOfPage);
    }
  }, [props.numberOfPage]);

  useEffect(() => {
    if (props.currentPage !== null) {
      setCurrentPage(props.currentPage);
    }
  }, [props.currentPage]);

  useEffect(() => {
    if (props.patientListLoading !== null) {
      setPatientsLoading(props.patientListLoading);
    }
  }, [props.patientListLoading]);

  useEffect(() => {
    if (props.patientOldNameLoading) {
      setPatientOldNamesLoading(props.patientOldNameLoading);
    }
  }, [props.patientOldNameLoading]);

  useEffect(() => {
    if (patients.length !== 0) {
      setPatients([])
    }

    if (props.onSelectPatient) {
      props.onSelectPatient(null, hnInput)
    }
  }, [hnInput])

  // For controller
  useEffect(() => {
    if (props.controller) {
    }
  }, [props.controller]);

  return (
    <React.Fragment>
      <Input
        id={"InputPatientSearchBox"}
        ref={inputRef}
        value={hnInput === "" ? props.defaultValue : hnInput}
        disabled={props.disabled}
        onChange={props.forcedSelectHN ? null : handleOnChangeHN}
        onKeyPress={handleOnKeyPressHN}
        action={{
          icon: props.forcedSelectHN ? "pin" : "search",
          onClick: props.forcedSelectHN ? null : handleOpenCardPatientSearch,
          type: "button",
        }}
      />
      <Modal open={openCardPatientSearch} size={props.modalSize}>
        <CardPatientSearch
          hnPreData={hnInput}
          isAPILoading={isAPILoading}
          // Data
          nationalitiesList={nationalities}
          patientListLoading={patientsLoading}
          patientList={patients}
          numberOfPage={numberOfPage}
          currentPage={currentPage}
          // callback
          onPaginationChange={
            props.onPatientListPaginationChange
              ? props.onPatientListPaginationChange
              : handlePaginationChange
          }
          hideCallBack={handleCloseCardPatientSearch}
          hideColumnsByAccessor={props.hideColumnsByAccessor}
          hideNationality={props.hideNationality}
          hideCitizenID={props.hideCitizenID}
          getNationality={
            props.getNationality ? props.getNationality : loadNationality
          }
          getPatientList={
            props.getPatientList ? props.getPatientList : loadPatients
          }
          onSelectPatient={(id, hn, name) => {
            console.log(id, hn, name);
            setHNInput(hn);
            setPatientId(id)
            setTimeout(() => {
              props.onSelectPatient(id, hn, name);
              handleCloseCardPatientSearch();
            }, 0);
          }}
          onOpenModPatientOldName={handleOpenModPatientOldName}
        />
      </Modal>
      <Modal open={openCardPatientOldName}>
        <CardPatientOldName
          hideCallBack={handleCloseCardPatientOldName}
          hn={hnInput}
          fullName={patientFullName}
          patientOldNameLoading={patientOldNamesLoading}
          patientOldNameDataList={patientOldNames}
        />
      </Modal>
    </React.Fragment>
  );
});

PatientSearchBox.defaultProps = {
  // Initial data
  initialValue: "",
  defaultValue: "",
  patientListLoading: false,
  patientOldNameLoading: false,
  forcedSelectHN: null,
  disabled: false,
  // modalSize: "fullscreen",

  // Return data
  patientList: [],
  nationalitiesList: [],
  patientOldNameDataList: [],
  // Pagination
  numberOfPage: 1,
  currentPage: 1,

  // Loading function
  getPatientList: null,
  getNationality: null,
  onGetPatientOldName: null,
  onGetPatientByHN: null,
  onPatientListPaginationChange: null,

  // Callback function
  onSelectPatient: () => { },
  onEnter: () => { },
  // Controller
  controller: null,
  hideColumnsByAccessor: [],
  hideNationality: false,
  hideCitizenID: false
};

PatientSearchBox.propTypes = {
  // Initial data
  initialValue: PropTypes.string,
  defaultValue: PropTypes.string,
  patientListLoading: PropTypes.bool,
  patientOldNameLoading: PropTypes.bool,
  forcedSelectHN: PropTypes.string,
  disabled: PropTypes.bool,
  // modalSize: PropTypes.string,

  // Return data
  patientList: PropTypes.array,
  nationalitiesList: PropTypes.array,
  patientOldNameDataList: PropTypes.array,
  // Pagination
  numberOfPage: PropTypes.number,
  currentPage: PropTypes.number,

  // Loading function
  getPatientList: PropTypes.func,
  getNationality: PropTypes.func,
  onGetPatientOldName: PropTypes.func,
  onGetPatientByHN: PropTypes.func,
  onPatientListPaginationChange: PropTypes.func,

  // Calllback function
  onSelectPatient: PropTypes.func,

  onEnter: PropTypes.func,
  // Controller
  controller: PropTypes.object,
  hideColumnsByAccessor: PropTypes.array,
  hideNationality: PropTypes.bool,
  hideCitizenID: PropTypes.bool
};

export default React.memo(PatientSearchBox);
